module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-grid",
    class: [
      _vm.align && ("o-grid--" + _vm.align),
      _vm.size && ("o-grid--" + _vm.size),
      _vm.space && ("o-grid--" + _vm.space),
      {
        'o-grid--stretch': _vm.stretch,
        'o-grid--wrapped': _vm.wrapped,
        'o-grid--liquid': _vm.liquid,
        'o-grid--auto o-grid--liquid': _vm.auto,
        'o-grid--reverse': _vm.reverse
      }
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369821de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/Grid.vue
// module id = 52
// module chunks = 1